import { useEffect, useState } from "react";
import { get_event_rsvp, update_event_rsvp } from "../../api/event";
import StatusBadge from "../StatusBadge";
import { CaretLeft, CaretRight } from "phosphor-react";
import { Navigate, useNavigate } from "react-router-dom";
import Modal from "react-modal";
import { toast } from "react-toastify";
import { X } from "phosphor-react";
import { Helmet } from "react-helmet";
import { getWithExpiry } from "../../utils/storage";
import { sleep } from "../RSVPForm/RSVPForm";


const guests = [
  { id: '1', name: 'Sophia Carter', status: 'regular' },
  { id: '2', name: 'Ethan Bennett', status: 'regular' },
  { id: '3', name: 'Olivia Hayes', status: 'vvip' },
  { id: '4', name: 'Liam Foster', status: 'regular' },
  { id: '5', name: 'Ava Morgan', status: 'vip' },
  { id: '6', name: 'Noah Parker', status: 'regular' },
  { id: '7', name: 'Isabella Reed', status: 'vvvip' },
  { id: '8', name: 'Jackson Cole', status: 'regular' },
  { id: '9', name: 'Mia Brooks', status: 'vip' },
  { id: '10', name: 'Lucas Gray', status: 'regular' }
];

const GuestList = (props) => {
  const [rsvps, setRSVPs] = useState([])
  const [loading, setLoading] = useState(false)
  const [dataFetchFailed, setDataFetchFailed] = useState(false)
  const [errMsg, setErrMsg] = useState('')
  const [nextPageNo, setNextPageNo] = useState(0)
  const [totalPages, setTotalPages] = useState(1)
  const [searchQuery, setSearchQuery] = useState("")
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [displayType, setDisplayType] = useState("approve")  
  const [inputValues, setInputValues] = useState({
    class: "",
  });
  const [err, setErr] = useState({    

    class: "",
    email: "",
  });
  const [guestIndex, setGuestIndex] = useState(null)
  const [scheduleIndex, setScheduleIndex] = useState(0)

  const navigate = useNavigate();

  const customStyles = {
    content: {
      // top: '50%',
      // left: '50%',
      // right: 'auto',
      // bottom: 'auto',
      // marginRight: '-50%',
      zIndex: 99999,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.2)",
      backdropFilter: "blur(2px)",
    },
  };

  useEffect(() => {
    getEventRsvp()
  }, [])

  const getEventRsvp = async () => {
    
    try {
      // setLoading(true)
      const rsvpManagerSession = getWithExpiry('rsvp-manager-session-' + props.event_id);
      const params = {
        event_id: props.event_id ?? '',
        session_key: rsvpManagerSession,
        limit_page_start: 0,
        limit_page_length: 20,
        // status: props.status,
      }
      console.log('get_event_rsvp params', params)
      const res = await get_event_rsvp(params)
      const response = await res.json()
      console.log('get_event_rsvp', response)
      setLoading(false)
      if (res.ok) {
        setDataFetchFailed(false)
        setRSVPs(response.data?.result)
        setNextPageNo(response?.data?.next_page ?? 0)
        setTotalPages(response?.data?.total_pages ?? 1)
      } else {
        setDataFetchFailed(true)
        setErrMsg(response?.message)
      }

    } catch (error) {
      setDataFetchFailed(true)
      setErrMsg("Oops... Something went wrong")
    }
  } 

  const onSearch = async (event) => {
    try {
      event?.preventDefault(); // Prevent page refresh
    } catch (error) {
      
    }
    
    try {
      // setLoading(true)
      const rsvpManagerSession = getWithExpiry('rsvp-manager-session-' + props.event_id);
      const params = {
        event_id: props.event_id ?? '',
        session_key: rsvpManagerSession,
        limit_page_start: 0,
        limit_page_length: 20,
        search_string: searchQuery,
      }
      console.log('onSearch get_event_rsvp params', params)
      const res = await get_event_rsvp(params)
      const response = await res.json()
      console.log('onSearch get_event_rsvp', response)
      setLoading(false)
      if (res.ok) {
        setDataFetchFailed(false)
        setRSVPs(response.data?.result)
        setNextPageNo(response?.data?.next_page ?? 0)
        setTotalPages(response?.data?.total_pages ?? 1)
      } else {
        setDataFetchFailed(true)
        setErrMsg(response?.message)
      }

    } catch (error) {
      setDataFetchFailed(true)
      setErrMsg("Oops... Something went wrong")
    }
  } 

  const handleSearchQueryChange = async (event) => {
    const target = event.target;

    const value =
      target.type === "checkbox" || target.type === "radio"
        ? target.checked
        : target.value;
    const name = target.name;

    setSearchQuery(value)

    if (searchQuery && value === "") {
      getEventRsvp()
    }
  };

  const goBack = async () => {
    
    try {
      // console.log("nextPageNo", nextPageNo);
      // console.log("totalPages", totalPages);
      // return
      
      if (nextPageNo -1 <= 0) {
        setNextPageNo(0)
        return
      }
      // setLoading(true)
      const rsvpManagerSession = getWithExpiry('rsvp-manager-session-' + props.event_id);
      const params = {
        event_id: props.event_id ?? '',
        session_key: rsvpManagerSession,
        limit_page_start: nextPageNo - 1,
        limit_page_length: 20,
      }

      if (Boolean(searchQuery?.length)) {
        params['search_string'] = searchQuery
      }

      setNextPageNo(nextPageNo - 1)

      console.log('get_event_rsvp params', params)
      const res = await get_event_rsvp(params)
      const response = await res.json()
      console.log('get_event_rsvp', response)
      setLoading(false)
      if (res.ok) {
        setDataFetchFailed(false)
        setRSVPs(response.data?.result)
        setNextPageNo(response?.data?.next_page ?? 0)
        setTotalPages(response?.data?.total_pages ?? 1)
      } else {
        setDataFetchFailed(true)
        setErrMsg(response?.message)
      }

    } catch (error) {
      setDataFetchFailed(true)
      setErrMsg("Oops... Something went wrong")
    }
  } 

  const goNext = async () => {
    
    try {
      if (nextPageNo >= totalPages) {
        return
      }
      // setLoading(true)
      const rsvpManagerSession = getWithExpiry('rsvp-manager-session-' + props.event_id);
      const params = {
        event_id: props.event_id ?? '',
        session_key: rsvpManagerSession,
        limit_page_start: nextPageNo + 1,
        limit_page_length: 20,
        // status: props.status,
      }
      if (Boolean(searchQuery?.length)) {
        params['search_string'] = searchQuery
      }
      setNextPageNo(nextPageNo + 1)
      
      console.log('get_event_rsvp params', params)
      const res = await get_event_rsvp(params)
      const response = await res.json()
      console.log('get_event_rsvp', response)
      setLoading(false)
      if (res.ok) {
        setDataFetchFailed(false)
        setRSVPs(response.data?.result)
        setNextPageNo(response?.data?.next_page ?? 0)
        setTotalPages(response?.data?.total_pages ?? 1)
      } else {
        setDataFetchFailed(true)
        setErrMsg(response?.message)
      }

    } catch (error) {
      setDataFetchFailed(true)
      setErrMsg("Oops... Something went wrong")
    }
  } 

  const toggleModal = (value) => {
    setModalIsOpen(value);
  };

  const handleInputChange = (event) => {
    const target = event.target;

    const value =
      target.type === "checkbox" || target.type === "radio"
        ? target.checked
        : target.value;
    const name = target.name;

    setInputValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const updateRSVP = async (status) => {
    try {
      setIsSubmitting(true);
      toggleModal(false)

      const rsvpManagerSession = getWithExpiry('rsvp-manager-session-' + props.event_id);

      var params = {
        event_id: props.event_id ?? '',
        session_key: rsvpManagerSession,
        invitation_type: inputValues.class,
        rsvp_id: rsvps[guestIndex].rsvp_id,
        status,
      }

      console.log('params', params);

      const res = await update_event_rsvp(params)
      const response = await res.json()
      console.log('res', res.status);
      console.log('response', response);
      setIsSubmitting(false);
      if (res.ok) {
        const tempRSVPs = rsvps 
        tempRSVPs[guestIndex] = {
          ...tempRSVPs[guestIndex],
          status,
          invitation_type: status === 'Approved' ? inputValues.class : 'Regular',
        }
        setRSVPs(tempRSVPs)
        toast.success(response?.message ?? `RSVP ${status}` , {
          position: "top-right",
          autoClose: 15000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        toast.error(response.message, {
          position: "top-right",
          autoClose: 15000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        
      }

    } catch (error) {
      toast.error("Something went wrong. Error: " + error.message, {
        position: "top-center",
        autoClose: 15000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }

  const confirmArrival = async (index) => {
    try {
      setIsSubmitting(true);
      toggleModal(false)

      const rsvpManagerSession = getWithExpiry('rsvp-manager-session-' + props.event_id);

      var params = {
        event_id: props.event_id ?? '',
        session_key: rsvpManagerSession,
        rsvp_id: rsvps[index].rsvp_id,
        guest_attendance: rsvps[index].guest_attendance[scheduleIndex].schedule_id,
      }

      console.log('params', params);

      const res = await update_event_rsvp(params)
      const response = await res.json()
      console.log('res', res.status);
      console.log('response', response);
      setIsSubmitting(false);
      if (res.ok) {
        const tempRSVPs = rsvps 
        tempRSVPs[index].guest_attendance[scheduleIndex].checked_in = 1
        setRSVPs(tempRSVPs)
        toast.success(response?.message ?? `Arrival confirmed` , {
          position: "top-right",
          autoClose: 15000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        toast.error(response.message, {
          position: "top-right",
          autoClose: 15000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        
      }

    } catch (error) {
      toast.error("Something went wrong. Error: " + error.message, {
        position: "top-center",
        autoClose: 15000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }



  return (
    <div>
      <form
        className="sm:flex sm:flex-row align-center mt-4 mb-10"
        onSubmit={onSearch}
        
      >
        <input
          type="search"
          value={searchQuery}
          name="search"
          placeholder="Search guest name or access code"
          onChange={handleSearchQueryChange}
          required
          // className={this.props.is_erred ? "outline-input-field-erred" : (this.state.is_focus ? "outline-input-field-active" : "outline-input-field")}
          // className="input-field"
          className={`formInput `}
          
        />
        <input
          type="submit"
          value="Search"
          className={`formInput bg-light-green-500 sm:w-auto sm:ml-4 sm:mt-0 mt-4`}
        />
      </form>
      {
        Boolean(rsvps?.length) && (
          <div className="bg-card rounded-lg border border-border overflow-hidden">
            <div className="flex flex-row bg-muted border-b border-border justify-between">

              {
                rsvps[0]?.guest_attendance.map((item, index) => {
                  return (
                    <div 
                      className={"flex items-center flex-1 border-l px-6 py-3 cursor-pointer " + (
                        index === scheduleIndex ? "border-b-4 bg-light-green-50 border-b-light-green-500" : " hover:bg-light-green-100"
                      )}
                      onClick={() => {
                        setScheduleIndex(index)
                      }}
                    >
                      <h3 className="text-sm font-semibold font-sora text-muted-foreground">{item.schedule_name}</h3>
                    </div>
                  )
                })
              }
              
              
              {/* Pagination control */}
              {
                (totalPages > 1) && (
                  <div
                    className="flex flex-row align-center content-center items-center justify-center"
                  >
                    <p
                      className="text-[12px] mr-3"
                    >
                      {nextPageNo - 1} of {totalPages }
                    </p>
                    <div
                      className="flex flex-row gap-4 align-center content-center"
                    >
                      <div
                        onClick={goBack}
                        className="cursor-pointer"
                      >
                        <CaretLeft size={14} />
                      </div>
                      <div
                        onClick={goNext}
                        className="cursor-pointer"
                      >
                      <CaretRight size={14} />
                      </div>
                    </div>
                  </div>
                )
              }
              
            </div>
            
            <div className="divide-y divide-border">
              {rsvps.map((guest, index) => (
                <div
                  key={index} 
                  className="px-6 py-2 flex flex-wrap items-center justify-between"
                  // onClick={() => {
                  //   navigate(`/rsvp-details?event_id=${props.event_id}`, { state: guest });
                  // }}
                >
                  <div className="flex items-center flex-1 py-2">
                    <span className="text-foreground font-medium">{guest?.guest_name}</span>
                    {
                      props.status === "Approved" && (
                        <StatusBadge status={guest?.invitation_type ?? "Regular"} />
                      )
                    } 
                    {
                      Boolean(rsvps[index].guest_attendance[scheduleIndex].checked_in) && (
                        <button 
                          className="font-medium ml-2 text-[12px] inline-flex items-center px-2 sm:px-4 py-2 rounded-full bg-blue-200 text-blue-800"
                          onClick={() => {
                            confirmArrival(index)
                          }}  
                        >
                          Arrived
                        </button>
                      )
                    }
                  </div>
                  
                  <div className="flex items-center space-x-4 py-2">                
                          
                    {
                      guest?.status === 'Pending' && (
                        <button 
                          className="font-medium text-[12px] inline-flex items-center px-2 sm:px-4 py-2 rounded-full bg-orange-200 text-orange-800 hover:bg-orange-300"
                          onClick={() => {
                            setGuestIndex(index)
                            setDisplayType('decline')
                            setModalIsOpen(true)
                          }}
                        >
                          Decline
                        </button>
                      )
                    }
                    {
                      guest?.status === 'Pending' && (
                        <button 
                          className="font-medium text-[12px] inline-flex items-center px-2 sm:px-4 py-2 rounded-full bg-light-green-500 text-green-1000 hover:bg-light-green-600"
                          onClick={() => {
                            setGuestIndex(index)
                            setDisplayType('approve')
                            setModalIsOpen(true)
                          }}
                        >
                          Approve
                        </button>
                      )
                    }
                    {
                      (guest?.status === 'Cancelled' || guest?.status === 'Declined') && (
                        <button 
                          className="font-medium text-[12px] inline-flex items-center px-2 sm:px-4 py-2 rounded-full bg-light-green-500 text-green-1000 hover:bg-light-green-600"
                          onClick={() => {
                            setGuestIndex(index)
                            setDisplayType('approve')
                            setModalIsOpen(true)
                          }}
                        >
                          Re-Approve
                        </button>
                      )
                    }
                    {
                      (guest?.status === 'Approved' && !Boolean(rsvps[index].guest_attendance[scheduleIndex].checked_in)) && (
                        <button 
                          className="font-medium text-[12px] inline-flex items-center px-2 sm:px-4 py-2 rounded-full bg-light-green-500 text-green-1000 hover:bg-light-green-600"
                          onClick={() => {
                            confirmArrival(index)
                          }}  
                        >
                          Confirm Arrival
                        </button>
                      )
                    }
                    {
                      guest?.status === 'Approved' && (
                        <button 
                          className="font-medium text-[12px] inline-flex items-center px-2 sm:px-4 py-2 rounded-full bg-orange-200 text-orange-800 hover:bg-orange-300"
                          onClick={() => {
                            setGuestIndex(index)
                            setDisplayType('cancel')
                            setModalIsOpen(true)
                          }}
                        >
                          Cancel RSVP
                        </button>
                      )
                    }
                    
                  </div>
                </div>
              ))}
            </div>
          </div>
        )
      }

      {
        !Boolean(rsvps?.length) && (
          <div
            className="mt-10 border-grey-200 p-4 rounded-[6px] border-[1px]"
          >
            <p>
              {
                Boolean(searchQuery?.length) ? 
                "No matching guest information" :
                "No guests yet!"
              }
            </p>
          </div>
        )
      }
      
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => toggleModal(false)}
        style={customStyles}
        // contentLabel="Vessel Modal"
        // overlayClassName="modal-overlay"
        className="vessel-modal"
      >
        {
          displayType === 'approve' && (
            <div className="mt-[250px] bg-white rounded-xl p-5 m-4 w-[320px] sm:w-[460px] lg:p-[30px]">
              <div className="flex justify-end pb-2">
                <div className="" onClick={() => toggleModal(false)}>
                  <X weight="bold" className="text-base font-semibold" />
                </div>
              </div>
              <p 
                className="font-sora text-new-black-500 text-lg font-medium"
              >
                Guest Invitation Class
              </p>
              <p className="font-sora text-new-black-500 text-sm mt-3">
                Invitation Class
              </p>

              <select
                name="class"
                id="class"
                // className="input-field"
                className={`formInput mt-5 ${Boolean(err.class.length) ? "border-red-500" : ""
                  }`}
                value={inputValues.class}
                onChange={handleInputChange}
                required
              >
                <option value="" defaultValue disabled>
                  Select Class
                </option>
                <option value="Regular" key="Regular">
                  Regular
                </option>
                <option value="VIP" key="VIP">
                  VIP
                </option>
                <option value="VVIP" key="VVIP">
                  VVIP
                </option>
              </select>

              {Boolean(err.class.length) ? (
                <p className="input-field-err-msg">{err.class}</p>
              ) : null}

              <button
                className="primaryButton w-full mt-[30px]"
                onClick={() => {
                  updateRSVP('Approved')
                }}
              >
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </button>
            </div>
          )
        }
        
        {
          displayType === 'decline' && (
            <div className="mt-[250px] bg-white rounded-xl p-5 m-4 w-[320px] sm:w-[460px] lg:p-[30px]">
              <div className="flex justify-end pb-2">
                <div className="" onClick={() => toggleModal(false)}>
                  <X weight="bold" className="text-base font-semibold" />
                </div>
              </div>
              <p 
                className="font-sora text-new-black-500 text-lg font-medium"
              >
                Please Confirm
              </p>
              <p className="font-sora text-new-black-500 text-sm mt-3">
                Are you sure you want to decline this RSVP request?
              </p>

              <button
                className="secondaryButton w-full mt-[30px]"
                onClick={() => {
                  setModalIsOpen(false)
                }}
              >
                No, take me back
              </button>
              <button
                className="primaryButton w-full mt-[15px]"
                onClick={() => {
                  updateRSVP('Declined')
                }}
              >
                Yes, I want to
              </button>
            </div>
          )
        }
        {
          displayType === 'cancel' && (
            <div className="mt-[250px] bg-white rounded-xl p-5 m-4 w-[320px] sm:w-[460px] lg:p-[30px]">
              <div className="flex justify-end pb-2">
                <div className="" onClick={() => toggleModal(false)}>
                  <X weight="bold" className="text-base font-semibold" />
                </div>
              </div>
              <p 
                className="font-sora text-new-black-500 text-lg font-medium"
              >
                Please Confirm
              </p>
              <p className="font-sora text-new-black-500 text-sm mt-3 ">
                Are you sure you want to CANCEL this RSVP request?
              </p>

              <button
                className="secondaryButton w-full mt-[30px]"
                onClick={() => {
                  setModalIsOpen(false)
                }}
              >
                No, take me back
              </button>
              <button
                className="primaryButton w-full mt-[15px]"
                onClick={() => {
                  updateRSVP('Declined')
                }}
              >
                Yes, I want to
              </button>
            </div>
          )
        }
        
      </Modal>
    </div>
  );
};

export default GuestList;